/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { VTextProfile } from '../models/v-text-profile';
import { VTextProfilesGridResult } from '../models/v-text-profiles-grid-result';
import { VTextProfilesRequestModel } from '../models/v-text-profiles-request-model';

@Injectable({
  providedIn: 'root',
})
export class VTextProfilesService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation vTextProfilesGetVTextProfiles
   */
  static readonly VTextProfilesGetVTextProfilesPath = '/api/VTextProfiles/list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vTextProfilesGetVTextProfiles()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  vTextProfilesGetVTextProfiles$Response(params: {
    body: VTextProfilesRequestModel
  }): Observable<StrictHttpResponse<VTextProfilesGridResult>> {

    const rb = new RequestBuilder(this.rootUrl, VTextProfilesService.VTextProfilesGetVTextProfilesPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<VTextProfilesGridResult>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `vTextProfilesGetVTextProfiles$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  vTextProfilesGetVTextProfiles(params: {
    body: VTextProfilesRequestModel
  }): Observable<VTextProfilesGridResult> {

    return this.vTextProfilesGetVTextProfiles$Response(params).pipe(
      map((r: StrictHttpResponse<VTextProfilesGridResult>) => r.body as VTextProfilesGridResult)
    );
  }

  /**
   * Path part for operation vTextProfilesGet
   */
  static readonly VTextProfilesGetPath = '/api/VTextProfiles/{id}';

  /**
   * Get VText Profile By Id.
   *
   * Get VText Profile By Id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vTextProfilesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  vTextProfilesGet$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<VTextProfile>> {

    const rb = new RequestBuilder(this.rootUrl, VTextProfilesService.VTextProfilesGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<VTextProfile>;
      })
    );
  }

  /**
   * Get VText Profile By Id.
   *
   * Get VText Profile By Id
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `vTextProfilesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vTextProfilesGet(params: {
    id: number;
  }): Observable<VTextProfile> {

    return this.vTextProfilesGet$Response(params).pipe(
      map((r: StrictHttpResponse<VTextProfile>) => r.body as VTextProfile)
    );
  }

  /**
   * Path part for operation vTextProfilesDelete
   */
  static readonly VTextProfilesDeletePath = '/api/VTextProfiles/{id}';

  /**
   * Delete VText Profile By Id.
   *
   * Delete VText profile By Id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vTextProfilesDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  vTextProfilesDelete$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<boolean>> {

    const rb = new RequestBuilder(this.rootUrl, VTextProfilesService.VTextProfilesDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * Delete VText Profile By Id.
   *
   * Delete VText profile By Id
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `vTextProfilesDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vTextProfilesDelete(params: {
    id: number;
  }): Observable<boolean> {

    return this.vTextProfilesDelete$Response(params).pipe(
      map((r: StrictHttpResponse<boolean>) => r.body as boolean)
    );
  }

  /**
   * Path part for operation vTextProfilesPost
   */
  static readonly VTextProfilesPostPath = '/api/VTextProfiles';

  /**
   * Save VText Profile.
   *
   * Save VText Profile
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vTextProfilesPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  vTextProfilesPost$Response(params: {
    body: VTextProfile
  }): Observable<StrictHttpResponse<VTextProfile>> {

    const rb = new RequestBuilder(this.rootUrl, VTextProfilesService.VTextProfilesPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<VTextProfile>;
      })
    );
  }

  /**
   * Save VText Profile.
   *
   * Save VText Profile
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `vTextProfilesPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  vTextProfilesPost(params: {
    body: VTextProfile
  }): Observable<VTextProfile> {

    return this.vTextProfilesPost$Response(params).pipe(
      map((r: StrictHttpResponse<VTextProfile>) => r.body as VTextProfile)
    );
  }

}
